import { Injectable } from '@angular/core';
import { AdultsInstituteTypeEnum, AgeGroupEnum, LectureValuesData } from '../lecture.values';

@Injectable({
  providedIn: 'root'
})
export class LectureValuesService {
  private normalizedAgeGroups: any[];
  private normalizedAdultsInstituteType: any[];

  constructor() {
    this.normalizedAgeGroups = this.normalizeAllAgeGroupNames();
    this.normalizedAdultsInstituteType = this.normalizeAllAdultsInstituteTypes();
  }

  getAgeGroupInfo(ageGroupName: string, skyz: boolean = false): any {
    const normalizedName = this.normalize(ageGroupName);
    const filtered: AgeGroupEnum[] = this.normalizedAgeGroups.filter(ageGroup => {
      return skyz ? (normalizedName === ageGroup.skyz) :
        (normalizedName === ageGroup.normName) || (normalizedName === ageGroup.normEngName);
    });

    return filtered[0];
  }

  getAdultsInstituteType(adultsInstituteType: string): any {
    const normalizedName = this.normalize(adultsInstituteType);
    const filtered: AdultsInstituteTypeEnum[] = this.normalizedAdultsInstituteType.filter(adultGroup => {
      return (normalizedName === adultGroup.normName) || (normalizedName === adultGroup.normEngName);
    });

    return filtered[0];
  }

  private normalizeAllAgeGroupNames(): any[] {
    return LectureValuesData.ageGroups.filter((ageGroup: any) => {
      const nameHE = this.normalize(ageGroup.nameHE);
      const nameEN = this.normalize(ageGroup.nameEN);
      ageGroup.normName = nameHE;
      ageGroup.normEngName = nameEN;
      return ageGroup;
    });
  }

  private normalizeAllAdultsInstituteTypes(): any[] {
    return LectureValuesData.adultsInstituteTypes.filter((adultType: any) => {
      const nameHE = this.normalize(adultType.nameHE);
      const nameEN = this.normalize(adultType.nameEN);
      adultType.normName = nameHE;
      adultType.normEngName = nameEN;
      return adultType;
    });
  }

  private normalize(str: string): string {
    return str.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
  }
}
